export default "__VITE_ASSET__qwDsVB4P__"